import { render, staticRenderFns } from "./ImportPostsModal.vue?vue&type=template&id=b126dec0"
import script from "./ImportPostsModal.vue?vue&type=script&lang=ts"
export * from "./ImportPostsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports